import React, { Component } from 'react'
import { Button, Image, Modal, Form, Input, TextArea, Message } from 'semantic-ui-react'
import ChatIcon from '../../images/ChatIcon.png'
import Logo from '../../images/logo.png'
import emailjs from 'emailjs-com'
import agent from '../../../axios/agent'
import ReCAPTCHA from 'react-google-recaptcha'

class NewContactFormTR extends Component {
  state = {
    user_email: '',
    user_subject: '',
    message: '',
    onFormGoing: false,
    captchaToken: '',
    captchaError: false,
    lastSubmitTime: null,
    errorMessage: '',
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { user_email, user_subject, message, captchaToken, lastSubmitTime } = this.state

    const now = new Date()
    if (lastSubmitTime && (now - lastSubmitTime) / 1000 < 30) {
      this.setState({ errorMessage: 'Lütfen tekrar denemeden önce birkaç saniye bekleyin.' })
      return
    }

    if (!captchaToken) {
      this.setState({ captchaError: true, errorMessage: 'Lütfen robot olmadığınızı doğrulayın.' })
      return
    }

    const templateParams = {
      user_email,
      user_subject,
      message,
    }

    const form = {
      VisitorEmail: user_email,
      VisitorSubject: user_subject,
      VisitorMessage: message.toUpperCase(),
      CaptchaToken: captchaToken,
      CreatedDate: new Date()
    }

    emailjs.send(
      'gmail_service',
      'template_h9kkxvm',
      templateParams,
      'user_sYzG1ti0KxwG2LJiHJmYg'
    ).then(() => {
      agent.ContactFormList.create(form)
        .then((response) => {
          if (response.status === 200) this.resetForm()
        })
    }).catch(() => {
      this.setState({ errorMessage: 'Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.' })
    })
  }

  resetForm() {
    this.setState({
      user_email: '',
      user_subject: '',
      message: '',
      captchaToken: '',
      onFormGoing: true,
      captchaError: false,
      lastSubmitTime: new Date(),
      errorMessage: '',
    })
  }

  handleChange = (param, e) => {
    this.setState({ [param]: e.target.value })
  }

  handleCaptchaChange = (token) => {
    this.setState({ captchaToken: token, captchaError: false, errorMessage: '' })
  }

  render() {
    const { onFormGoing, user_email, user_subject, message, captchaError, errorMessage } = this.state

    return (
      <Modal
        trigger={
          <Button
            style={{
              position: 'fixed',
              bottom: '15px',
              right: '15px',
              height: '%20',
              padding: '10px',
              borderRadius: 100,
              backgroundColor: '#007bff',
            }}
          >
            <img src={ChatIcon} alt='' style={{ maxHeight: '50px' }} />
          </Button>
        }
        style={{
          position: 'relative',
          overflowX: 'scrolling',
          backgroundRepeat: 'relative',
          height: 'auto'
        }}
      >
        {onFormGoing ? (
          <Message positive>
            <Message.Header>Başarılı</Message.Header>
            <p>Mesajınız <b>başarı</b> ile gönderildi.</p>
          </Message>
        ) : null}

        <Modal.Header>
          <Image src={Logo} centered verticalAlign='middle' />{' '}Birgi Mefar Group
        </Modal.Header>

        <Modal.Content>
          BMG websitemize hoşgeldiniz, iletişim formumuzu eksiksiz doldurmanız halinde İş Geliştirme Ekibimiz sizinle en kısa sürede iletişime geçiyor olacaktır.
          <Form style={{ marginTop: '20px' }} onSubmit={this.handleSubmit}>
            <Form.Field>
              <label>Email Adresiniz</label>
              <Input
                type='email'
                name='user_email'
                value={user_email}
                onChange={(e) => this.handleChange('user_email', e)}
                placeholder='Email Adresiniz'
                required
              />
            </Form.Field>

            <Form.Field>
              <label>Konu</label>
              <Input
                type='text'
                name='user_subject'
                value={user_subject}
                onChange={(e) => this.handleChange('user_subject', e)}
                placeholder='Konu'
                required
              />
            </Form.Field>

            <Form.Field>
              <label>Mesaj</label>
              <TextArea
                name='message'
                value={message}
                onChange={(e) => this.handleChange('message', e)}
                required
              />
            </Form.Field>

            <Form.Field>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={this.handleCaptchaChange}
              />
              {captchaError && <p style={{ color: 'red' }}>Lütfen robot olmadığınızı doğrulayın.</p>}
            </Form.Field>

            {errorMessage && <Message negative>{errorMessage}</Message>}

            <Button positive type='submit'>Gönder</Button>
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

export default NewContactFormTR
